import ga from 'ga';
import 'sass/cadremploi-webapp/widget/bloc-cv.scss';
import '@ce/kit-ui/scss/_button.scss';

function getLabel(configuration) {
  let label = 'depot_cv';
  if (configuration.hasCV) {
    label = configuration.visibleCVTheque ? 'maj_cv' : 'completion_cv';
  }
  return label;
}

function blocCV(configuration) {
  const label = getLabel(configuration);
  const cta = document.querySelector('.js-cta');

  cta.addEventListener('click', e => {
    ga.sendEvent('editorial', 'clic_bloc_cv_edito', label);
  });

  document.addEventListener('DOMContentLoaded', () => {
    ga.sendNonInteractiveEvent('editorial', 'affichage_bloc_cv_edito', label);
  });
}

export default blocCV;
